import { actions, types } from './requests'
export const GETBABYPRESSADATAFILTER_TYPES = {
    ...types('GETBABYPRESSADATAFILTER'),
}
export const GETBABYPRESSADATAFILTER_ACTIONS = {
    ...actions('GETBABYPRESSADATAFILTER'),
}
